/**
 * Формирование абсолютного адреса картинки
 * @param path
 */
export const imageLink = (path?: string | null) => {
  if (!path) {
    return '';
  }

  // если путь начинается с http, то хост не добавляется
  if (path.startsWith('http')) {
    return path;
  }

  return import.meta.env.VITE_APP_ENV === 'local'
    ? `${import.meta.env.VITE_API_URL}${path}`
    : path;
};
